import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'

import { resolveResidentAppErrorMessage } from '../utils/resolveResidentAppErrorMessage'

import { Error } from 'components'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ children }) => {
  const { t } = useTranslation(['errors', 'common'])

  const fallbackRender = ({ error }: FallbackProps) => {
    const resolved = resolveResidentAppErrorMessage(error as Error, t)
    return (
      <Error
        message={resolved.message}
        illustration={resolved.illustration}
        eventId={resolved.eventId}
      />
    )
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  )
}
